/// <reference path='../_all.ts' />

module library {
  'use strict';
  
  export class ServiceData {
    constructor(
      public Documents : DocumentCategory[],
      public Languages : Language[]
      ) { }
  }

}